var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircleCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.6 4.54a1 1 0 0 1 .01 1.4l-5.66 5.67a1 1 0 0 1-1.36.05l-.05-.05-.02-.02L3.7 8.77a1 1 0 0 1-.07-1.32l.08-.09a1 1 0 0 1 1.4 0l2.13 2.12 4.96-4.95a1 1 0 0 1 1.32-.07l.09.08z"
}))));
export default SvgCircleCheck;